// extracted by mini-css-extract-plugin
export default {"add":"AddProduct_add__UlXct","add1":"AddProduct_add1__Ns1qV"};